<template>
  <div>
    <el-row>
      <el-col :span="2" class="padding-r-0">
        <div class="border-radius">
          <div class="margin-xs-r treeview">
            <ul class="list-group text-center border-radius">
              <li class="list-group-item node-orgTree" v-for="(item, index) in shopOrderInfo.types" :key="index"
                @click="swatchType(item)" :class="{ 'vc-node-selected': shopOrderInfo.typeCd == item.value }">
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span="22">
        <el-row>
          <el-col :span="12" class="padding-lr-sm">
            <shop-order-cart ref="shopOrderCart"></shop-order-cart>
          </el-col>
          <el-col :span="12" class="padding-lr-sm">
            <shop-order-group ref="shopOrderGroup"></shop-order-group>
          </el-col>
          <el-col :span="12" class="padding-lr-sm">
            <shop-order-seckill ref="shopOrderSeckill"></shop-order-seckill>
          </el-col>
          <el-col :span="12" class="padding-lr-sm">
            <shop-order-refund ref="shopOrderRefund"></shop-order-refund>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ShopOrderCart from '@/components/order/shopOrderCart/shopOrderCart'
import ShopOrderGroup from '@/components/order/shopOrderGroup/shopOrderGroup'
import ShopOrderSeckill from '@/components/order/shopOrderSeckill/shopOrderSeckill'
import ShopOrderRefund from '@/components/order/shopOrderRefund/shopOrderRefund'

export default {
  name: 'ShopOrder',
  components: {
    ShopOrderCart,
    ShopOrderGroup,
    ShopOrderSeckill,
    ShopOrderRefund
  },
  data() {
    return {
      shopOrderInfo: {
        shopOrders: [],
        types: [{
          name: '订单类',
          value: 'order'
        }],
        typeCd: 'order',
        machineId: ''
      }
    }
  },
  methods: {
    swatchType(_data) {
      this.shopOrderInfo.typeCd = _data.value
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.padding-lr-sm {
  padding-left: 10px;
  padding-right: 10px;
}

.border-radius {
  border-radius: 4px;
}

.margin-xs-r {
  margin-right: 5px;
}

.treeview {
  height: 100%;
}

.list-group {
  list-style: none;
  padding: 0;
  margin: 0;
}

.list-group-item {
  padding: 10px 15px;
  border: 1px solid #ddd;
  margin-bottom: -1px;
  cursor: pointer;
}

.text-center {
  text-align: center;
}

.node-orgTree {
  background-color: #f5f5f5;
}

.vc-node-selected {
  background-color: #409EFF;
  color: #fff;
}
</style>